import Info from '@mui/icons-material/Info'
import TableCell from '@mui/material/TableCell'
import TableRow from '@mui/material/TableRow'
import Typography from '@mui/material/Typography'

import StyledTable from '@components/StyledTable'
import { formatDateTime } from '@util/date-util'

import { StyledIconButton } from '../../../theme/components/StyledIconButton'
import type { HistorySelection } from '../types/HistorySelection'
import type { LeveringStatus } from '../types/LeveringStatus'

const headerCells = [
  { id: 'levering-id', numeric: false, label: 'Levering ID' },
  { id: 'levering-status', numeric: false, label: 'Status' },
  { id: 'levering-created', numeric: false, label: 'Aangemaakt' },
  { id: 'levering-datum', numeric: false, label: 'Gewijzigd' },
  { id: 'acties', numeric: false, label: 'Acties' },
]

const defaultSort = (x, y) =>
  Number(new Date(y.changed)) - Number(new Date(x.changed))

interface Props {
  leveringen: LeveringStatus[]
  isError: boolean
  onOpenHistory: (selection: HistorySelection) => void
}

export const Leveringen = ({ leveringen, onOpenHistory, isError }: Props) => {
  return (
    <StyledTable
      variant="details"
      isError={isError}
      headerCells={headerCells}
      {...({} as any)}
    >
      {[...leveringen].sort(defaultSort).map((item) => {
        const {
          changed,
          leveringStatusText,
          leveringId,
          leveringType,
          created,
        } = item

        return (
          <TableRow key={leveringId}>
            <TableCell>
              <>
                {leveringId}
                <br />
                <Typography variant="caption">{leveringType}</Typography>
              </>
            </TableCell>
            <TableCell>{leveringStatusText}</TableCell>
            <TableCell>{formatDateTime(created)}</TableCell>
            <TableCell>{formatDateTime(changed)}</TableCell>
            <TableCell>
              {
                <StyledIconButton
                  icon={<Info />}
                  title={`Open ${leveringType} ${leveringId} historie`}
                  onClick={() =>
                    onOpenHistory({ changedField: 'levering', leveringId })
                  }
                />
              }
            </TableCell>
          </TableRow>
        )
      })}
    </StyledTable>
  )
}
